import { render, staticRenderFns } from "./TheSiteWideLinks.vue?vue&type=template&id=ae0bca6e&scoped=true&"
var script = {}
import style0 from "./TheSiteWideLinks.vue?vue&type=style&index=0&id=ae0bca6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0bca6e",
  null
  
)

export default component.exports